if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('button');
        this.setupEventListeners();
        this.syncButtonState();
      }

      setupEventListeners() {
        this.button.addEventListener('click', (event) => {
          this.expandShowMore(event);
          const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');
          if (
            nextElementToFocus &&
            !nextElementToFocus.classList.contains('hidden') &&
            nextElementToFocus.querySelector('input')
          ) {
            nextElementToFocus.querySelector('input').focus();
          }
        });
      }

      syncButtonState() {
        const parentDisplay = this.closest('.parent-display');
        if (!parentDisplay) return;

        const showMoreItems = parentDisplay.querySelectorAll('.show-more-item');
        const isExpanded = showMoreItems.length > 0 && !showMoreItems[0].classList.contains('hidden');

        this.querySelectorAll('.label-text').forEach((element) => {
          element.classList.toggle('hidden', isExpanded === element.classList.contains('label-show-more'));
        });

        const parentWrap = parentDisplay.querySelector('.parent-wrap');
        if (parentWrap) {
          parentWrap.classList.toggle('more-shown', isExpanded);
        }

        if (!this.querySelector('.label-show-less') && !isExpanded) {
          this.classList.remove('hidden');
        }
      }

      expandShowMore(event) {
        const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
        const parentWrap = parentDisplay.querySelector('.parent-wrap');

        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));

        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));

        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }

        parentWrap.classList.toggle('more-shown');
      }
    }
  );
}
